/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type FiltersDirectoryType from '@jira/spa-apps__directories-filters/src/FiltersDirectoryType.tsx';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const FiltersDirectoryRedirect = (): React.JSX.Element => (
	<ScreenRedirect to="/jira/filters" />
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyFiltersDirectory: LazyComponent<(props: Record<any, any>) => React.JSX.Element> =
	lazyForPaint<typeof FiltersDirectoryType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-filters-directory", jiraSpaEntry: "async-filters-directory" */ '@jira/spa-apps__directories-filters/src/FiltersDirectoryType.tsx'
			),
		),
	);

export const FiltersDirectoryComponent = (): React.JSX.Element => (
	<LazyPage Page={LazyFiltersDirectory} pageId="filters-directory" shouldShowSpinner={false} />
);
